<template>
    <div>
        <b-modal id="create-ticket" title="Ticket Kaydı" no-close-on-esc no-close-on-backdrop>
            <employee-ticket-create-or-update v-model="ticket"/>
            <template #modal-footer><v-executer :loading="saving" :action="save">Ekle</v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    :search="false"
                    :settings="false"
                    :add-callback="createNew"
                    ></v-table>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import EmployeeTicketCreateOrUpdate from './EmployeeTicketCreateOrUpdate.vue'

export default {
    components:{
        EmployeeTicketCreateOrUpdate
    },
    props:{
        id:[String,Number],
    },
    data(){
        return {
            fields:[
                {name:'Kart Numarası',key:'CardNumber',thClass:'text-nowrap w-50'},
                {name:'Referans Kodu',key:'RefCode',thClass:'text-nowrap w-50'},
                {name:'Aktif',key:'Active'}
            ],
            buttons:[
                { text:"Aktif Et",key:"active",icon:"CheckCircleIcon",variant:"success",action:this.toggle,condition:i => !i.Active},
                { text:"Deaktif Et",key:"deactive",icon:"XCircleIcon",variant:"danger",action:this.toggle,condition:i => i.Active},
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete},
            ],
            ticket:{
                Id:null,
                CardNumber:null,
                RefCode:null,
            },
            saving:false,
        }
    },
    methods:{
        clearForm(){
            this.ticket.Id = null
            this.ticket.CardNumber = null
            this.ticket.RefCode = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-ticket')
        },
        provider(){
            return EmployeeOperationsApi.TikcetNew.List(this.id)
        },
        save(){
            this.saving = true
            EmployeeOperationsApi.TikcetNew.Create({
                ...this.ticket,
                EmployeeId:this.id
            }).then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-ticket')
                }
                this.saving = false
                this.$result(res)
            }).catch(err => {
                this.saving = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.RefCode} referans numaralı ticket kaydını silecektir geri alınamaz.`).then(result=>{
                if(result){
                    this.$refs.table.rowLoading(true)
                    EmployeeOperationsApi.TikcetNew.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$refs.table.rowLoading(false)
                        this.$result(res)
                    }).catch(err=>{
                        this.$refs.table.rowLoading(false)
                        this.$result(null,err)
                    })
                }
            })
        },
        toggle(item){
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.TikcetNew.ToggleActiveStatus(item.Id).then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                }
                this.$refs.table.rowLoading(false)
                this.$result(res)
            }).catch(err=>{
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        }
    }
}
</script>